import React from "react";
import "./Certificate.css";
import Image from "../Image/Image";

const Certificate = ({ certificate }) => {
    if (!certificate?.imgUrl) return null;

    return (
        <div className="Certificate">
            <div className="Certificate__image">
                <Image imgUrl={certificate.imgUrl} />
            </div>
        </div>
    );
};

export default Certificate;